import type { TFunction } from 'i18next';

import { Rule } from '@/shared/types/rules';
import { Version } from '@/shared/types/version';

import { ConnectedRule } from './VersionTooltipContent';

/** Draft (version 0) first, then newest. */
export const byDraftFirst = (a: Version, b: Version) => {
  if (a.version === 0) {
    return -1;
  }
  if (b.version === 0) {
    return 1;
  }
  return b.version - a.version;
};

export const getVersionLabel = (t: TFunction, version: number) =>
  version === 0 ? t('common.draft') : `v${version}`;

/** Buckets the rules that assign `brainId` by the brain version they assign. */
export const groupRulesByVersion = (
  rules: Pick<Rule, 'rule_id' | 'name' | 'desk_id' | 'actions'>[] | undefined,
  brainId: string
) => {
  const map = new Map<number, ConnectedRule[]>();
  rules?.forEach(({ rule_id, name, desk_id, actions }) => {
    const versions = new Set(
      actions
        ?.filter(({ brain_parent_id }) => brain_parent_id === brainId)
        .map(({ brain_version }) => brain_version)
    );
    versions.forEach((version) => {
      map.set(version, [...(map.get(version) ?? []), { rule_id, name, desk_id }]);
    });
  });
  return map;
};
